var style = {"otpContainer":"OneTimePasscode-module_otpContainer__bIkRr","disabledStyle":"OneTimePasscode-module_disabledStyle__e0XjQ","errorStyle":"OneTimePasscode-module_errorStyle__N1SVp","danger":"OneTimePasscode-module_danger__bsoLS"};

export { style as default };
//# sourceMappingURL=OneTimePasscode.module.scss.js.map
